/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { jingleCollectionModelPagedResultSchema } from "../jingleCollectionModelPagedResultSchema.ts";
import { z } from "zod";

export const getApiJingleCollectionsQueryParamsSchema = z.object({
    "SortByName": z.boolean().describe("Сортировка по наименованию").optional(),
"SortByNameDesc": z.boolean().describe("Сортировка по наименованию с конца").optional(),
"SortByDate": z.boolean().describe("Сортировка по дате").optional(),
"SortByDateDesc": z.boolean().describe("Сортировка по дате с конца").optional(),
"SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Список подборок джинглов
 */
export const getApiJingleCollections200Schema = z.lazy(() => jingleCollectionModelPagedResultSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiJingleCollections400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiJingleCollections401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiJingleCollections403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiJingleCollections500Schema = z.lazy(() => badResponseModelSchema)

export const getApiJingleCollectionsQueryResponseSchema = z.lazy(() => getApiJingleCollections200Schema)